<template>
  <div>
    <card>
      <template slot="header">
        <h4 class="card-title">{{ $t('seasonTickets.detailsTitle') }}</h4>
      </template>
      <div v-loading="loading">
        <season-ticket-details v-if="details" :details="details"/>
        <div class="button-container mt-3" v-if="details">
          <div class="row">
            <div class="col-md-6 col-lg-3" v-if="$auth.can({season_ticket: 'update'}, 'permissions')">
              <edit-season-ticket :current-details="details"/>
            </div>
            <div class="col-md-6 col-lg-3" v-if="$auth.can({season_ticket: 'delete'}, 'permissions')">
              <el-tooltip :content="$t('seasonTickets.delete.deleteBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="danger" @click.native="handleDelete()" class="mt-0">
                  <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('seasonTickets.delete.deleteBtnLabel') }}
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </card>
    <season-ticket-revisions-table :season-ticket-id="this.$route.params.id" :season-ticket="details"/>
  </div>
</template>
<script>
import SeasonTicketDetails from './SeasonTicket/SeasonTicketDetails';
import EditSeasonTicket from "./EditSeasonTicket";
import SeasonTicketRevisionsTable from "../SeasonTicketRevisions/SeasonTicketRevisionsTable";

import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";

export default {
  name: "SeasonTicket",
  components: {
    SeasonTicketDetails,
    EditSeasonTicket,
    SeasonTicketRevisionsTable
  },
  computed: {
    ...mapState({
      loading: state => state.season_tickets.loading,
      error: state => state.season_tickets.error,
      details: state => state.season_tickets.single,
    }),
  },
  watch: {
    '$route.params.id': function (id) {
      this.GetSeasonTicket(id)
    }
  },
  methods: {
    ...mapActions(['GetSeasonTicket', 'DeleteSeasonTicket', 'UpdateSeasonTicket']),
    handleDelete() {
      swal({
        title: this.$t('seasonTickets.delete.text'),
        text: `'${this.details.id}'`,
        confirmButtonText: this.$t('seasonTickets.delete.actionBtnLabel'),
        cancelButtonText: this.$t('seasonTickets.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          const oldDetails = this.details
          this.DeleteSeasonTicket(this.details.id).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('seasonTickets.delete.successNotification', oldDetails),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.$router.push({name: 'season_tickets'})
            }

          })
        }
      });
    },
  },
  mounted() {
    this.GetSeasonTicket(this.$route.params.id)
  }
};
</script>
<style></style>
